// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SiteLeads_WebhookResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /site/v1/webhooks/leads (HTTP 202).
 *
 * `duplicate` is the whole idempotency contract made visible: the site's retry
 * gets 202 with the SAME lead_id and duplicate:true, so a retry loop can stop
 * without guessing whether its first attempt landed.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SiteLeads_WebhookResponseDados {
event_id: string
lead_id: number
duplicate: boolean
}

export type SiteLeads_WebhookResponse = ApiResponse<SiteLeads_WebhookResponseDados>;

registerResponseContract('SiteLeads_WebhookResponse', {
  event_id:  { type: 'string',  required: true },
  lead_id:   { type: 'number',  required: true },
  duplicate: { type: 'boolean', required: true },
})
